module.exports = __webpack_public_path__ + "img/Magdalena.f89acead.png";